import type React from 'react';
import { Icon } from '@/components/atoms/primitives/Icon';
import { classNames } from '@/lib/utils';
import type { MapControlButtonProps } from './MapControlButton.types';

export const MapControlButton: React.FC<MapControlButtonProps> = ({
  icon,
  tooltip,
  onClick,
  loading = false,
  containerClassName = '',
  buttonClassName = '',
  iconClassName = '',
  'aria-label': ariaLabel,
}) => {
  return (
    <div className={containerClassName}>
      <button
        onClick={onClick}
        disabled={loading}
        className={classNames('map-control-button', buttonClassName)}
        aria-label={ariaLabel || tooltip}
        title={tooltip}
        type="button"
      >
        <Icon name={icon} className={classNames('map-control-button-icon', iconClassName)} />
      </button>
    </div>
  );
};
